import { FC } from 'react';

import { useFormContext } from 'old-rhf';

import { BaseToggle, BaseToggleProps } from '@zazume/zzm-base';

interface ToggleProps extends BaseToggleProps {
  name: string;
}

/**
 * @deprecated use ZZMForm.Toggle instead
 * @param props
 * @constructor
 */
export const Toggle: FC<ToggleProps> = props => {
  const { register } = useFormContext();

  return <BaseToggle {...props} ref={register} />;
};
